var map = {
	"./guy-avatar@3x.png": "gWhh",
	"./nofar-avatar@3x.png": "pwaO",
	"./yael-avatar@3x.png": "Tfbv"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9MCg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cx-avatars ^\.\/.*\-avatar@3x\.png$
// module id = 9MCg
// module chunks = 6